
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticPaths, GetStaticProps } from 'next';
import { languagePage } from '@/components/transcription-landing/landingPages';
import { languageExample } from '@/components/transcription-landing/languageExample';
import TranscriptionLanding from '@/components/transcription-landing/TranscriptionLanding';
import { findTranscriptionLanguagePage, TRANSCRIPTION_LANGUAGE_PAGES, } from '@/constants/transcriptionLanguagePages';
type Props = {
    slug: string;
};
export default function LanguageTranscriptionPage({ slug }: Props) {
    const language = findTranscriptionLanguagePage(slug);
    if (!language)
        return null;
    return (<TranscriptionLanding page={languagePage(language, languageExample(language))} currentLanguage={language.slug}/>);
}
const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
    const slug = String(params?.language ?? '');
    const language = findTranscriptionLanguagePage(slug);
    if (!language)
        return { notFound: true };
    return { props: { slug: language.slug } };
};
// Every locale the site has: each language page lists all of them as
// alternates, so a locale left out here would be a broken hreflang link.
export const getStaticPaths: GetStaticPaths = async ({ locales }) => ({
    paths: TRANSCRIPTION_LANGUAGE_PAGES.flatMap((language) => (locales ?? ['en']).map((locale) => ({
        params: { language: language.slug },
        locale,
    }))),
    fallback: false,
});

    async function __Next_Translate__getStaticProps__1a12e86ef8a__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/[language]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12e86ef8a__ as getStaticProps }
  